import axios from "axios";

// Origem do servidor (para a API e assets estáticos, como a logo em /uploads):
// - REACT_APP_API_URL definida → usa ela (permite trocar o back sem recompilar).
// - Produção → back no Railway (o front vive à parte, no Cloudflare Pages).
// - Desenvolvimento → back local na 3001.
// Obs.: o fallback de produção é a URL do Railway de propósito — assim o build
// funciona mesmo que a variável de ambiente não seja injetada no CI do host.
const API_URL_PADRAO = "https://app-production-2e8a.up.railway.app";
const SERVER_URL =
    process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === "production" ? API_URL_PADRAO : "http://localhost:3001");

// Toda a API vive sob /api (evita colidir com as rotas do front na mesma origem).
const API_BASE_URL = `${SERVER_URL}/api`;

/** Instância única do axios: injeta o token JWT e trata sessão expirada */
const api = axios.create({ baseURL: API_BASE_URL });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        // Token inválido/expirado → volta para o login
        if (error.response?.status === 401 && !error.config.url.includes("/auth/")) {
            localStorage.removeItem("token");
            localStorage.removeItem("usuario");
            window.location.href = "/login";
        }
        return Promise.reject(error);
    }
);

export { API_BASE_URL, SERVER_URL };
export default api;
